import remarkGfm from 'remark-gfm';
/** Shared remark plugins array for react-markdown usage. */
export const REMARK_PLUGINS = [remarkGfm];
//# sourceMappingURL=markdown-config.js.map